export function handleCarouselMobileHeight() {
    const carouselItems = document.querySelectorAll('.aegis-carousel-item');
	if (!carouselItems) {
		return;
	}
	carouselItems.forEach(carouselItem => {
		const carouselItemImgContainer = carouselItem.querySelector('.aegis-carousel-item-img-container .elementor-widget-theme-post-featured-image') as HTMLElement;
		if (window.innerWidth < 768) {
			carouselItemImgContainer.style.height = 'unset';
			const carouselItemImgContainerWidth = parseFloat(window.getComputedStyle(carouselItemImgContainer).getPropertyValue("width")).toFixed(2);
			carouselItemImgContainer.style.height = `${carouselItemImgContainerWidth}px`;
		} else {
			carouselItemImgContainer.style.height = 'unset';
		}
		
	})
	window.addEventListener("resize", handleResize);
	function handleResize() {
		carouselItems.forEach(carouselItem => {
			const carouselItemImgContainer = carouselItem.querySelector('.aegis-carousel-item-img-container .elementor-widget-theme-post-featured-image') as HTMLElement;
			if (window.innerWidth < 768) {
				carouselItemImgContainer.style.height = 'unset';
				const carouselItemImgContainerWidth = parseFloat(window.getComputedStyle(carouselItemImgContainer).getPropertyValue("width")).toFixed(2);
				carouselItemImgContainer.style.height = `${carouselItemImgContainerWidth}px`;
			} else {
				carouselItemImgContainer.style.height = 'unset';
			}
		})
	}
}